export default __webpack_public_path__ + "static/media/map-fs-icon-selected.df2541ba.svg";